<template>
  <l-default>
    <div v-if="isLoggedIn">
      <PageDirectCall v-if="isMobile"/>
      <Dashboard v-else />
    </div>
    <div v-else>
      <PageFreeDirectCall v-if="isMobile"/>
      <PageFreeCall v-else />
    </div>
  </l-default>
</template>

<script>
import { mapGetters } from 'vuex'
import LDefault from '../layouts/LDefault'
import PageFreeDirectCall from '@/pages/PageFreeDirectCall.vue'
import Dashboard from '@/components/Dashboard.vue'
import PageDirectCall from '@/pages/PageDirectCall.vue'
import PageFreeCall from '@/pages/PageFreeCall.vue'

export default {
  name: 'PageHome',
  components: { PageFreeCall, PageDirectCall, Dashboard, PageFreeDirectCall, LDefault },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  data: function () {
    return {
      isMobile: true
    }
  },
  async mounted () {
    let self = this
    setTimeout(function () { self.isMobile = self.$isMobile() }, 100)
  }
}
</script>
